<template>
  <nav class="pcoded-navbar">
    <div class="sidebar_toggle">
      <a href="#"><i class="icon-close icons"></i></a>
    </div>
    <div class="pcoded-inner-navbar main-menu sidebar-scroll">
      <div class="">
        <div class="main-menu-header">
          <img
            class="img-40 img-radius"
            src="../assets/img/avatar-4.jpg"
            alt="User-Profile-Image"
          />
          <div class="user-details">
            <span>{{ user_name }}</span>
            <span id="more-details" style="text-transform: none"
              >{{ user_email }}<i class="ti-angle-down"></i
            ></span>
          </div>
        </div>

        <div class="main-menu-content">
          <ul>
            <li class="more-details">
              <a href="/settings"><i class="ti-settings"></i>Settings</a>
              <a href="#" v-on:click.prevent="logout"
                ><i class="ti-layout-sidebar-left"></i>Logout</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="pcoded-navigatio-lavel" data-i18n="nav.category.navigation">
        Menu
      </div>

      <Menu />
    </div>
  </nav>
</template>
<style scoped>
ul {
  padding-left: 0 !important;
  list-style-type: none !important;
  margin-bottom: 0 !important;
}
.sidebar-scroll {
  max-height: 100vh;
  overflow-y: auto;
}

/* Scoped scrollbar styles */
.sidebar-scroll::-webkit-scrollbar {
  width: 6px;
  height: 2px;
}

.sidebar-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.sidebar-scroll::-webkit-scrollbar-thumb {
  background: #9ca3af;
  border-radius: 5px;
}
</style>
<script>
import Menu from "./Menu";
export default {
  name: "navbar2",
  data() {
    return {
      user_name: "",
      user_role: "",
      user_email: "",
    };
  },
  components: {
    Menu,
  },
  methods: {
    logout() {
      var r = window.confirm("Are you sure you want to logout?");
      if (r == true) {
        this.$store.dispatch("logout");
        window.location.reload();
        //console.log(this.$store.getters)
      } else {
        //
      }
    },
  },
  mounted() {
    var user = this.$store.getters.user_data;
    this.user_name = user.data.first_name + " " + user.data.last_name;
    this.user_email = user.data.email;
  },
};
</script>